export const AppMessages = {
  login: {
    invalidPermission: 'You do not have the permission in this site. Please contact administrator for more information.'
  },
  errors: {
    required: 'The {0} is required.', //The <field name> is required.
    newPassSameOldPass: 'The new password must be different from the old password.',
    invalidPassPolicy: 'Your password does not meet the length or complexity requirements.',
    newPassNotMatchConfirmPass: 'New password and Confirm new password do not match.',
    invalidEmail: 'The Email is invalid.',
    invalidFile: 'Cannot upload this file, system only accepts these file extensions jpg, png, gif, svg, and the file size must be less than or equal to 2Mb.',
    invalidDate: 'Date is invalid format.',
    invalidCourse: 'The valid range is from 0 to 999',
    invalidDateRangeWaitingRoom: 'Arrival To must be greater than Arrival From.',
    invalidMonthRangeWaitingRoom: 'The date range must be within 6 months.',
    invalidDateOfBirth: 'The date of birth must not be in future.',
    invalidDateAccountPayment: 'Date To must be greater than Date From.',
    invalidMinLength: 'Please enter at least 3 characters.',
    invalidDateBookingDateLargeGroup: 'Not allow selecting on date in the past and the date that more than 1 month from current date',
    invalidDateBooking: 'Return Date must be greater or equal to Depart Date.',
    invalidExelFile: 'Cannot upload this file, system only accepts these file extensions xls, xlsx and the file size must be less than or equal to 2Mb.',
    invalidEmailDuplicate: 'This email is already in use.',
  },
  success: {
    changePass: 'Your password has been changed.',
    registerAccount: 'Register successfully'
  },
  dialog: {
    successTitle: 'Confirmation Message',
    errorTitle: 'Error Message',
    yesButton: 'Yes',
    cancelButton: 'Cancel',
    noButton: 'No',
    closeButton: 'Close',
    saveButton: 'Save',
    createMessage: 'The content has been created successfully.',
    updateMessage: 'The content has been update successfully.',
    confirmMessage: 'Are you sure you want to remove {0}?'
  },
  user: {
    removeUser: 'Are you sure you want to remove this user from the centre?',
    disableUser: 'Are you sure you want to disable this user?',
    enableUser: 'Are you sure you want to enable this user?'
  },
  centre: {
    noUserAssigned: 'There is no user assigned to this centre.',
    removeUser: 'Are you sure you want to remove this user from the centre?',
    inactiveCentre: 'You are currently not assigned to any active centre. Please contact the administator for assistance.'
  },
  list: {
    noRecord: 'No record',
    total: 'total'
  },
  consultant: {
    errorSearch: 'Please enter at least one search criteria.',
    createMessage: 'Group is created successfully.',
  },
  individualConsultant: {
    removeUser: 'Are you sure you want to remove this patient from waiting room?'
  },
  groupConsultant: {
    confirmMessage: 'Are you sure you want to remove?',
    errorAddPatient: 'Please Select Patient',
    removeGroup: 'Are you sure you want to dismiss this group (all patients need to take individual consultation)?',
    removeUserFromeExistedGroup: 'Are you sure you want to remove patient from group or group consultation (all group recommendations are stored)?',
    removeUserFromCreateGroup : 'Are you sure you want to remove patient from group?'
  },
  payment: {
    successAllocate: 'Allocate credit note successfully',
    errorAllocate: 'System can only allow to allocate 1 invoice with 1 credit note.',
    errorAddOrder: 'Please select the invoice(s).',
    errorAddOrderForCN: 'System cannot add order number to credit note.',
    errorWithholdTax: 'Withhold Tax amount cannot be larger than Amount Open',
    errorWithholdTaxType: 'Withhold Tax amount must be a positive number.',
    confirmPay: 'The current paid amount is over the invoice amount, system will create credit note for the remaining amount. Do you want to proceed?',
    errorPayValue: 'Payment value must be a positive number.',
    errorPay: 'Please select 1 invoice only',
  },
  patient: {
    removePatient: 'Are you sure you want to remove this patient account?'
  },
  waitingRoom: {

  },
  viewCalendar: {
    removeEvent: 'Are you sure you want to remove the booking on this date?'
  },
  adminVaccine: {
    export: 'You are exporting information about a vaccination you have received. Please understand and accept that this certificate may not provide sufficient evidence at immigration or by other healthcare authorities. Do you understand and accept the limitations of using this facility?',
  },
  booking: {
    fluBookingConfirm: 'Are you sure you want to book on {0}?',
    bookingConfirm: 'Are you sure you want to make the booking in this time slot?',
    changeDate: 'Are you sure you want to change the booking date time?',
    discardConfirm: 'You are in booking process, system will discard your booking when you leave this page. Do you want to continue?',
    duplicateRecord: 'The First Name, Surname and Date of Birth must be unique.'
  },
  bookingDetails: {
    statusCancelled : 'This booking will be hidden from both Exodus and patient’s My TMB. Are you sure you want to continue?',
    remove: 'Are you sure you want to remove the booking on this date?'
  },
  requestForAppointment: {
    errorAddMember: 'System only allows 9 members in small group booking.',
    successBookAppointment: 'Thank you for booking to TMB clinic, your booking is created successfully. Our staff will contact for more information.',
    invalidEmailDuplicate: 'Email address must be unique.',
    errorMobile: 'Mobile Phone must be less than or equal to 24 characters.',
    errorName: 'First Name and Surname must be less than or equal to 50 characters and not include any special characters.',
    errorMemberSmallGroup: 'The group booking requires more than 1 member. Please add more members to the group booking.',
    errorMemberLargeGroup: 'The large group booking requires more than 9 member. Please add more members to the group booking.'
  },
  viewUploadDocument: {
    noShared: 'This file is no longer shared to the patient.',
    noDocument: 'There is no shared document for this consultation.'
  },
  viewInvoice: {
    noInvoice: 'There is no invoice for this consultation.',
    noConsultation: `You don't have any consultation in TMB clinic(s).`,
  },
  viewPrescription: {
    noPrescription: 'There is no prescription for this patient.'
  },
  account: {
    resentEmail: 'The active link has been sent to your email.'
  },
  flu: {
    notification: 'Please double-click to the available slot to make the booking.'
  },
  landing: {
    confirmMessage: 'Registered with TMB previously?'
  }

};



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/constants/messages.ts